export interface SetPlacar {
  numeroSet: number;
  gamesA: number | null;
  gamesB: number | null;
  tiebreakA?: number | null;
  tiebreakB?: number | null;
}

export interface Placar {
  resultadoFinalA?: number | null;
  resultadoFinalB?: number | null;
  sets: SetPlacar[];
}

export function calculateFinalResults(sets: SetPlacar[]): { resultadoFinalA: number; resultadoFinalB: number } {
  let resultadoFinalA = 0;
  let resultadoFinalB = 0;

  sets.forEach(set => {
    const { gamesA, gamesB, tiebreakA, tiebreakB } = set;
    
    if (gamesA !== null && gamesB !== null) {
      if (gamesA > gamesB) {
        resultadoFinalA++;
      } else if (gamesB > gamesA) {
        resultadoFinalB++;
      } else if (gamesA === gamesB && tiebreakA != null && tiebreakB != null) {
        if (tiebreakA > tiebreakB) {
          resultadoFinalA++;
        } else if (tiebreakB > tiebreakA) {
          resultadoFinalB++;
        }
      }
    }
  });

  return { resultadoFinalA, resultadoFinalB };
}

export function normalizeSets(sets?: SetPlacar[] | null, numeroSets?: number | null): SetPlacar[] {
  const byNumeroSet = new Map<number, SetPlacar>();
  let totalSets = numeroSets ?? 3; // Padrão de 3 sets para retrocompatibilidade
  // tratar Super tiebreak como set adicional
  // se o numeroSets for par, teremos Super tiebreak como set adicional
  // Ex: melhor de 4 sets = 4 + 1 Super tiebreak
  if (numeroSets && numeroSets % 2 === 0) {
    totalSets += 1;
  }

  (sets ?? []).forEach(set => {
    if (!set) {
      return;
    }
    const numeroSet = set.numeroSet;
    if (numeroSet >= 1 && numeroSet <= totalSets) {
      byNumeroSet.set(numeroSet, {
        numeroSet,
        gamesA: set.gamesA ?? null,
        gamesB: set.gamesB ?? null,
        tiebreakA: set.tiebreakA ?? null,
        tiebreakB: set.tiebreakB ?? null,
      });
    }
  });

  return Array.from({ length: totalSets }, (_, i) => {
    const numeroSet = i + 1;
    return byNumeroSet.get(numeroSet) ?? {
      numeroSet,
      gamesA: null,
      gamesB: null,
      tiebreakA: null,
      tiebreakB: null,
    };
  });
}
